<template>
  <div class="my-item z-info">
    <template v-if="list && list.items.length">
      <div style="min-height: 400px;">
        <Row :gutter="30">
          <Col span="8" v-for="(item, index) in list.items" :key="'releaseInt-' + index">
            <div class="match-list">
              <div class="match-list-l">
                <div class="d1">
                  <h1 v-if="item.userInfo">{{item.userInfo.Name || item.userInfo.NickName}}</h1>
                  <span v-if="item.userInfo">{{item.userInfo.JobTitle}}</span>
                </div>
                <template v-if="item.compInfo">
                  <div class="d2">{{item.compInfo.Name}}</div>
                  <div class="d3" v-if="item.userInfo">{{item.userInfo.PhoneNumber}}</div>
                  <div class="d4">发起配对请求</div>
                </template>
              </div>
              <div class="match-list-r">
                <img
                  :src="item.userInfo.HeadImgUrl"
                  alt="照片"
                  v-if="item.userInfo && item.userInfo.HeadImgUrl"
                />
                <img src="@/assets/img/empty.png" v-else />
                <span>申请时间：{{item.inTime | moment("YYYY/MM/DD")}}</span>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div class="my-page" v-if="totalCount > pageSize">
        <Page
          show-total
          show-elevator
          :page-size="pageSize"
          :current="pageIndex"
          :total="totalCount"
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        />
      </div>
    </template>
    <div class="u-empty" v-else>暂无数据</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "exhibition-business-match",
  data() {
    return {
      deleted: false,
      edit: false,
      add: false,
      list: null,
      editInfo: null,
      delInfo: null,

      pageSize: 10,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getMatchesByCompId: "companyModule/getMatchesByCompId"
    }),
    async init() {
      let arr = await this.getMatchesByCompId(this.option);
      if (arr && arr.items) {
        arr.items.map(c => {
          c.userInfo = c.userInfo ? JSON.parse(c.userInfo) : c.userInfo;
          c.joinInfo = c.joinInfo ? JSON.parse(c.joinInfo) : c.joinInfo;
          c.compInfo = c.compInfo ? JSON.parse(c.compInfo) : c.compInfo;
          c.exhibitionInfo = c.exhibitionInfo
            ? JSON.parse(c.exhibitionInfo)
            : c.exhibitionInfo;
        });
        this.list = arr;
        if (this.list) {
          this.pageSize = this.list.pageSize;
          this.pageIndex = this.list.pageIndex;
          this.totalCount = this.list.totalCount;
          this.$emit("showNum", this.list.totalCount);
        }
      }
    },
    showAdd() {
      this.add = true;
    },
    hideAdd() {
      this.add = false;
    },
    showEdit(item) {
      this.edit = true;
      this.editInfo = item;
    },
    hideEdit() {
      this.edit = false;
      this.editInfo = null;
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      
    },
    // exportInfo() {
    //   if (!(this.list && this.list.items)) {
    //     return;
    //   }
    //   const exData = this.transformData(this.list.items);
    //   require.ensure([], () => {
    //     const {
    //       export_json_to_excel
    //     } = require("../../../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
    //     const tHeader = ["姓名", "公司", "职位"]; //这个是表头名称 可以是iveiw表格中表头属性的title的数组
    //     const filterVal = ["name", "companyName", "jobTitle"]; //与表格数据配合 可以是iview表格中的key的数组
    //     const data = this.formatJson(filterVal, exData);
    //     export_json_to_excel(tHeader, data, "预约配对"); //列表excel  这个是导出表单的名称
    //     this.downloadLoading = false;
    //   });
    // },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    transformData(data) {
      // 转换数据
      let arr = [];
      data.forEach(c => {
        arr.push({
          name: c.userInfo.NickName,
          companyName: c.compInfo.Name,
          jobTitle: "无"
        });
      });
      return arr;
    }
  }
};
</script>

<style scoped lang="scss">
.match {
  &-list {
    width: 100%;
    height: 160px;
    margin: 0 20px 20px 0;
    background-color: #fff;
    border: solid 1px #e8e8e8;
    border-radius: 2px;
    display: flex;
    justify-content: space-around;
    padding: 0 21px 0 21px;
    &-l {
      .d1 {
        display: flex;
        padding-top: 20px;
        h1 {
          font-size: 18px;
          color: #333;
        }
        span {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: rgb(140, 140, 140);
          padding-left: 5px;
        }
      }
      .d2 {
        font-size: 14px;
        color: rgb(140, 140, 140);
      }
      .d3 {
        font-size: 16px;
        color: #262626;
        margin-top: 10px;
      }
      .d4 {
        font-size: 14px;
        color: #333;
        margin-top: 10px;
      }
    }
    &-r {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      img {
        width: 70px;
        height: 71px;
        margin-left: 55px;
      }
      span {
        font-size: 12px;
        color: #999;
        margin-bottom: 10px;
        text-align: right;
      }
    }
  }
}
</style> 
